import socketClient from 'socket.io-client'

const socket = __CLIENT ? socketClient({
    autoReconnect: true,
    ackTimeout: 10000
}) : null

export default socket


// WEBPACK FOOTER //
// ./src/client/core/socket.js